import { Component, OnInit } from "@angular/core";
import { AccountsService } from "./accounts.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "accountlist-component",
  template: require('./accountlist.component.html'),
  styles: [require('./accountlist.component.scss')]
})
export class AccountListComponent implements OnInit {
  accounts: any[];
  reverse: boolean;
  predicate: string = "created_at";
  onlyActive: boolean = true;
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;
  projects: any[] = [{ name: "Projects" }];
  employers: any[] = [{ name: "Employers" }];
  projectFilter: string;
  employerFilter: string;

  constructor(private service: AccountsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getAccounts().subscribe((it) => {
      this.getProjects();
      this.getEmployers();
      this.sortBy("it.created_at", "created_at");
    });
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getAccounts() {
    return this.service.getAccounts().map((accounts) => {
      this.accounts = accounts;
    });
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  editAccount(account: any) {
    AccountsService.currentAccount = account;
    this.router.navigate(["/editaccount"]);
  }

  viewDetailAccount(account: any) {
    AccountsService.currentAccount = account;
    this.router.navigate(["/accounts", account.id]);
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
  }

  getEmployers() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  getUserNames(account: any) {
    if (account.users) {
      if (account.users.length > 0) {
        return account.users.map((it) => {
          return it.name;
        });
      }
      return "<add users>";
    }
    return "";
  }

  showUsers(account: any) {
    AccountsService.currentAccount = account;
    this.router.navigate(["/users"]);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accountlist.component.ts